import React from "react";
import { IDiscographyType } from "types/discographyType";
import AppleMusicLogo from "images/png/logos/apple-music.png";
import VevoLogo from "images/png/logos/vevo.png";
import TidalLogo from "images/png/logos/tidal.png";

import styled from "styled-components";
import { Colors } from "utils/colors";
import Typography from "components/typography";
import { Link, useNavigate } from "react-router-dom";

interface IProps {
  data: IDiscographyType[];
}
const BlockView = ({ data }: IProps) => {
  const Navigate = useNavigate();

  const OpenMusicVideo = () => {
    Navigate(`/overview/discography/rated-tube/1`);
  };
  return (
    <Container>
      {data.map(({ coverImage, title, type, status, releaseDate }, i) => {
        return (
          <ItemContainer key={i} onDoubleClick={OpenMusicVideo}>
            <Status status={status}>
              <Typography color={Colors.white300}>{status}</Typography>
            </Status>
            <ImageContainer>
              <Logos>
                <LogoContainer>
                  <LogoImg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      viewBox="0 0 18 12"
                      fill="none"
                    >
                      <path
                        d="M9.00062 5.99969L11.8133 8.8121L9.00101 11.625L6.1882 8.8125L9.00062 5.99969ZM3.375 0.375648L6.18781 3.18739L3.37539 6.00031L0.562697 3.18778L3.375 0.375648ZM14.6251 0.374859L17.4377 3.1866L14.6255 5.99952L11.8126 3.18705L9.00062 5.99969L6.18781 3.18716L9.00023 0.375141L11.8129 3.18677L14.6251 0.374859Z"
                        fill="white"
                      />
                    </svg>
                  </LogoImg>
                </LogoContainer>
                <LogoContainer>
                  <LogoImg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      viewBox="0 0 17 6"
                      fill="none"
                    >
                      <path
                        d="M10.6307 5.0904L8.2824 0.998105L9.66515 0.998158L10.6308 2.85829L11.5967 0.998233L12.9795 0.998287L10.6307 5.0904ZM2.41091 5.09008L0.0624952 0.997785L1.44532 0.997839L2.411 2.85797L3.37689 0.997914L4.75964 0.997968L2.41091 5.09008ZM6.52095 1.86608C6.93103 1.86609 7.24878 2.14858 7.3462 2.57472L5.69412 2.57465C5.80438 2.13164 6.098 1.86606 6.52095 1.86608ZM8.57586 2.99993C8.57591 1.82588 7.65593 0.874074 6.52099 0.87403C5.38611 0.873986 4.46599 1.82572 4.46595 2.99977C4.4659 4.17381 5.38698 5.12562 6.55625 5.12567C7.49024 5.1257 8.22275 4.5612 8.46643 3.77939L7.22948 3.77934C7.05793 4.03323 6.80562 4.0982 6.55629 4.09819C6.07826 4.09817 5.77366 3.76911 5.67811 3.31869L8.55281 3.3188C8.56797 3.21479 8.57586 3.1083 8.57586 2.99993ZM14.8116 3.99222C14.2801 3.9922 13.8904 3.56702 13.8904 3.00013C13.8904 2.43325 14.2805 2.0081 14.8116 2.00812C15.3431 2.00814 15.7328 2.43339 15.7328 3.00021C15.7328 3.56709 15.343 3.99224 14.8116 3.99222ZM14.8117 0.874352C13.6376 0.874306 12.6858 1.82604 12.6858 3.00009C12.6857 4.17413 13.6375 5.12594 14.8115 5.12599C15.9856 5.12603 16.9374 4.1743 16.9374 3.00025C16.9375 1.82621 15.9858 0.874398 14.8117 0.874352Z"
                        fill="white"
                      />
                    </svg>
                  </LogoImg>
                </LogoContainer>
                <LogoContainer>
                  <LogoImg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <rect
                        x="3.02148"
                        y="1.43921"
                        width="10"
                        height="13.125"
                        fill="white"
                      />
                      <path
                        d="M15.4942 4.32767C15.4942 3.86642 15.4552 3.40702 15.345 2.95796C15.1472 2.13999 14.6807 1.51514 13.9828 1.0563C13.6237 0.821939 13.2285 0.678055 12.8085 0.602163C12.486 0.543583 12.1593 0.516872 11.8321 0.509403C11.8078 0.507076 11.7811 0.501913 11.7539 0.499585L4.23957 0.500188C4.1444 0.50769 4.04927 0.51239 3.9541 0.517091C3.48772 0.543832 3.02413 0.592618 2.5845 0.768438C1.74969 1.09807 1.14649 1.67422 0.794982 2.50443C0.673133 2.78521 0.611748 3.08291 0.568189 3.38573C0.531647 3.62995 0.511986 3.87653 0.504983 4.12308C0.504985 4.14276 0.500294 4.162 0.500295 4.18169L0.500908 11.8211C0.505608 11.9093 0.51078 11.9969 0.515446 12.085C0.54739 12.5956 0.613025 13.1009 0.828212 13.5696C1.23377 14.456 1.91488 15.0391 2.85004 15.3198C3.1111 15.4004 3.38486 15.437 3.65815 15.4613C4.005 15.4955 4.3514 15.5002 4.69825 15.5002L11.5924 15.4996C11.9196 15.4996 12.2468 15.4775 12.574 15.4362C13.0891 15.3701 13.5723 15.2186 14.0096 14.9308C14.5346 14.5838 14.9302 14.1249 15.1837 13.5511C15.3009 13.2872 15.3669 13.0069 15.4157 12.7233C15.4864 12.3009 15.5009 11.8734 15.5009 11.4463C15.4984 9.07297 15.5005 6.70009 15.498 4.32673L15.4942 4.32767ZM11.4806 6.82042L11.4809 10.39C11.4809 10.6512 11.4444 10.9076 11.3272 11.1443C11.1468 11.5128 10.8538 11.7448 10.4606 11.8574C10.2431 11.9207 10.0186 11.9549 9.79172 11.9648C9.1983 11.9943 8.68314 11.5913 8.5781 11.0053C8.48758 10.522 8.71957 9.98948 9.22719 9.74053C9.42734 9.64301 9.64481 9.58439 9.86185 9.54032C10.0985 9.48922 10.3353 9.44278 10.5696 9.38885C10.7431 9.34994 10.8551 9.24491 10.8893 9.06632C10.8991 9.02743 10.9015 8.9857 10.9015 8.94678C10.9014 7.81145 10.9013 6.67608 10.9012 5.54355C10.9012 5.50463 10.8937 5.46526 10.8843 5.4287C10.8599 5.33354 10.7915 5.2773 10.694 5.282C10.5937 5.2867 10.4962 5.30403 10.3987 5.32375C9.92246 5.41659 9.44669 5.5118 8.97282 5.60934L6.66104 6.07594C6.65118 6.07827 6.639 6.08344 6.62917 6.08344C6.45572 6.1322 6.39479 6.21049 6.38731 6.39097C6.38498 6.41768 6.38732 6.44489 6.38732 6.47159C6.38512 8.09775 6.38758 9.72388 6.38538 11.3496C6.3854 11.6135 6.35588 11.8722 6.25138 12.116C6.07799 12.5163 5.7705 12.7681 5.35567 12.8877C5.13587 12.951 4.91134 12.988 4.68164 12.9951C4.08356 13.0172 3.58524 12.6192 3.48303 12.0309C3.39485 11.5233 3.62683 10.9762 4.20288 10.7319C4.42741 10.6391 4.65943 10.588 4.89615 10.5392C5.07426 10.5026 5.25518 10.466 5.43329 10.4295C5.67234 10.3783 5.79703 10.2269 5.8092 9.98269L5.80919 9.88988C5.80904 8.03919 5.8089 6.1885 5.80875 4.33784C5.80874 4.25955 5.81856 4.18173 5.83543 4.10577C5.87947 3.92765 6.0065 3.82498 6.17712 3.78324C6.33602 3.7415 6.49962 3.71246 6.66038 3.67821C7.11926 3.58537 7.57582 3.49249 8.03467 3.40198L9.45305 3.1136C9.87304 3.03058 10.2902 2.94524 10.7102 2.86222C10.8471 2.83551 10.9863 2.80596 11.125 2.79609C11.3177 2.77923 11.4522 2.90109 11.4719 3.09655C11.4766 3.14297 11.4794 3.18936 11.4794 3.23578L11.4797 6.81762L11.4806 6.82042Z"
                        fill="url(#paint0_linear_402_1844)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_402_1844"
                          x1="8"
                          y1="0.499887"
                          x2="8.0012"
                          y2="15.4999"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FB5971" />
                          <stop offset="1" stop-color="#FA253D" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </LogoImg>
                </LogoContainer>
              </Logos>
              <Image src={coverImage} alt={title} />
            </ImageContainer>
            <TextArea>
              <div>
                <div style={{ cursor: "pointer" }} onClick={OpenMusicVideo}>
                  <Typography size="lg" weight="bold">
                    {title}
                  </Typography>
                </div>

                <TextLink to={"/"}>
                  <Typography
                    color={Colors.yellow300}
                    decoration="underline"
                    mt="0.4"
                  >
                    Vectra
                  </Typography>
                </TextLink>
                <Typography color={Colors.grey500} size="s" mt="0.4">
                  {releaseDate}
                </Typography>
              </div>
              <OptionsButton>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 30 30"
                  fill="none"
                >
                  <path
                    d="M15.0469 8.75049C13.6661 8.75049 12.5469 7.6312 12.5469 6.25049C12.5469 4.86978 13.6661 3.75049 15.0469 3.75049C16.4276 3.75049 17.5469 4.86978 17.5469 6.25049C17.5469 7.6312 16.4276 8.75049 15.0469 8.75049Z"
                    fill="#CDCDCD"
                  />
                  <path
                    d="M15 17.5C13.6193 17.5 12.5 16.3807 12.5 15C12.5 13.6193 13.6193 12.5 15 12.5C16.3807 12.5 17.5 13.6193 17.5 15C17.5 16.3807 16.3807 17.5 15 17.5Z"
                    fill="#CDCDCD"
                  />
                  <path
                    d="M14.9512 26.25C13.5704 26.25 12.4512 25.1307 12.4512 23.75C12.4512 22.3693 13.5704 21.25 14.9512 21.25C16.3319 21.25 17.4512 22.3693 17.4512 23.75C17.4512 25.1307 16.3319 26.25 14.9512 26.25Z"
                    fill="#CDCDCD"
                  />
                </svg>
              </OptionsButton>
            </TextArea>
          </ItemContainer>
        );
      })}
    </Container>
  );
};

export default BlockView;

const Container = styled.div`
  width: 100%;
  display: grid;
  justify-content: space-between;
  grid-template-columns: 32% 32% 32%;
  grid-row-gap: 1.6rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
  }
`;

const ItemContainer = styled.div`
  padding: 0.8rem;
  height: 100%;
  width: 100%;
  border-radius: 0.8rem;
  background: ${Colors.grey700};
  position: relative;
  overflow: hidden;
`;

const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 0.8rem;
  margin-bottom: 2.1rem;
`;

const Image = styled.img`
  width: 100%;
  object-fit: cover;
`;

const Logos = styled.div`
  position: absolute;
  top: 0.4rem;
  right: 1rem;
  display: flex;
  align-items: center;
  justify-content: end;
`;

const LogoContainer = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  margin-left: 1.5px;
  border-radius: 0.8rem;
`;

const LogoImg = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Status = styled.div<{ status: string }>`
  width: fit-content;
  position: absolute;
  z-index: 4;
  padding: 0.4rem 0.8rem;
  top: 0;
  left: 0;
  border-radius: 0px 4px 4px 0px;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.15);
  background-color: ${(props) =>
    props.status === "released"
      ? Colors.success
      : props.status === "inactive"
      ? Colors.danger
      : Colors.yellow500};
`;

const TextArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TextLink = styled(Link)`
  all: unset;
  cursor: pointer;
`;

const OptionsButton = styled.div`
  width: 3rem;
  height: 3rem;
  cursor: pointer;
`;
